import React from 'react'

import NewRegistrationDetailsLayout from 'presentation/hospital/layouts/DoctorRegister/NewRegistrationsDetails'

const NewRegistrationsDetails = () => {
  return <NewRegistrationDetailsLayout />
}

export default NewRegistrationsDetails
